export const FILTER_IDS = {
  TERMS: "terms",
  INDUSTRY: "industry",
  LOCATION: "location",
  REVENUE: "revenue",
  EMPLOYEE: "employee",
  NATURAL_LANGUAGE: "naturalLanguage",
  SAVED_SEARCHES: "savedSearches",
};

/** Temporary kill-switch: hide Natural Language filter entry points by default. */
export const SHOW_NATURAL_LANGUAGE_FILTER = false;

/** Filters shown as expandable sections in the V3 sidebar (saved searches live in the page title). */
export const SIDEBAR_FILTER_ORDER = [
  FILTER_IDS.TERMS,
  FILTER_IDS.INDUSTRY,
  FILTER_IDS.LOCATION,
  FILTER_IDS.REVENUE,
  FILTER_IDS.EMPLOYEE,
  ...(SHOW_NATURAL_LANGUAGE_FILTER ? [FILTER_IDS.NATURAL_LANGUAGE] : []),
];

/** Filters shown as chips in the V2 horizontal bar (saved searches sit in the actions row). */
export const HORIZONTAL_CHIP_ORDER = [
  FILTER_IDS.TERMS,
  FILTER_IDS.INDUSTRY,
  FILTER_IDS.LOCATION,
  FILTER_IDS.REVENUE,
  FILTER_IDS.EMPLOYEE,
  ...(SHOW_NATURAL_LANGUAGE_FILTER ? [FILTER_IDS.NATURAL_LANGUAGE] : []),
];

export const FILTER_CATEGORY_LABELS = {
  [FILTER_IDS.TERMS]: "Terms",
  [FILTER_IDS.INDUSTRY]: "Industry",
  [FILTER_IDS.LOCATION]: "Location",
  [FILTER_IDS.REVENUE]: "Revenue",
  [FILTER_IDS.EMPLOYEE]: "Employee",
  [FILTER_IDS.NATURAL_LANGUAGE]: "Natural Language",
  [FILTER_IDS.SAVED_SEARCHES]: "Saved Searches",
};

/**
 * Pick the first filter chip with values in a saved-search query.
 * Used when optionally opening a filter chip after loading a saved search.
 */
export function resolveFirstActiveFilterId(query) {
  if (!query || typeof query !== "object") return FILTER_IDS.TERMS;
  if (
    SHOW_NATURAL_LANGUAGE_FILTER &&
    String(query.NaturalLanguageQuery || "").trim()
  ) {
    return FILTER_IDS.NATURAL_LANGUAGE;
  }
  if ((query.TermsInclude || []).length || (query.TermsExclude || []).length) {
    return FILTER_IDS.TERMS;
  }
  if ((query.IndustryInclude || []).length || (query.IndustryExclude || []).length) {
    return FILTER_IDS.INDUSTRY;
  }
  if ((query.Location || []).length) return FILTER_IDS.LOCATION;
  if (query.RevenueLowerBound != null || query.RevenueUpperBound != null) {
    return FILTER_IDS.REVENUE;
  }
  if (query.EmployeesLowerBound != null || query.EmployeesUpperBound != null) {
    return FILTER_IDS.EMPLOYEE;
  }
  return FILTER_IDS.TERMS;
}
